import styles from './styles.module.scss'

import Step1Icon from './icons/step-1.svg'
import Step2Icon from './icons/step-2.svg'
import Step3Icon from './icons/step-3.svg'
import StepMobile1Icon from './icons/step-mobile-1.svg'
import StepMobile2Icon from './icons/step-mobile-2.svg'
import StepMobile3Icon from './icons/step-mobile-3.svg'
import { useTranslation } from 'utils/use-translation'

export default function HowToStartEarning() {
  const { t } = useTranslation()
  
  return (
    <>
      <div className={styles.howToStartEarning}>
        <div className={styles.item}>
          <img src={Step1Icon} alt="step 1" />
          <div className={styles.text}>
            <h5>{t('step_1_get_link')}</h5>
            <p>{t('share_referral_link')}</p>
          </div>
        </div>

        <div className={styles.item}>
          <img src={Step2Icon} alt="step 2" />
          <div className={styles.text}>
            <h5>{t('step_2_invite')}</h5>
            <p>{t('invite_to_sign_up')}</p>
          </div>
        </div>

        <div className={styles.item}>
          <img src={Step3Icon} alt="step 3" />
          <div className={styles.text}>
            <h5>{t('step_3_start_earning')}</h5>
            <p>{t('receive_up_to_02_while_active')}</p>
          </div>
        </div>
      </div>

      <div className={styles.mobile}>
        <div className={styles.item}>
          <img src={StepMobile1Icon} alt="step 1 mobile icon" />
          <div className={styles.text}>
            <h5>{t('step_1_get_link')}</h5>
            <p>{t('share_referral_link')}</p>
          </div>
        </div>

        <div className={styles.item}>
          <img src={StepMobile2Icon} alt="step 2 mobile icon" />
          <div className={styles.text}>
            <h5>{t('step_2_invite')}</h5>
            <p>{t('invite_to_sign_up')}</p>
          </div>
        </div>

        <div className={styles.item}>
          <img src={StepMobile3Icon} alt="step 3 mobile icon" />
          <div className={styles.text}>
            <h5>{t('step_3_start_earning')}</h5>
            <p>{t('receive_up_to_02_while_active')}</p>
          </div>
        </div>
      </div>
    </>
  )
}
